import { CREATING_PARDOT_FORM_FAILED, CREATING_PARDOT_FORM_REQUEST, CREATING_PARDOT_FORM_SUCCEDDED, DELETING_PARDOT_FORM_FAILED, DELETING_PARDOT_FORM_REQUEST, DELETING_PARDOT_FORM_SUCCEEDED, UPDATING_PARDOT_FORM_FAILED, UPDATING_PARDOT_FORM_REQUEST, UPDATING_PARDOT_FORM_SUCCEEDED } from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';

const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/1.0`;
const PARDOT_FORM_URL = `${apiUrl}/forms/pardot`;

/*
* Create Pardot Form
*/
export const createPardotForm = createAction(CREATING_PARDOT_FORM_REQUEST, (request) => {
    return {
        request: request
    };
})

const creatingPardotFormSucceeded = createAction(CREATING_PARDOT_FORM_SUCCEDDED, (response) => {
    return response;
})

const creatingPardotFormFailed = createAction(CREATING_PARDOT_FORM_FAILED, (error) => {
    return error;
})

function* createPardotFormSaga(action) {
    const { request } = action.payload;

    const createPardotFormAPI = () => {
        return axios.post(PARDOT_FORM_URL, request).then(response => response.data);
    }

    try {
        const response = yield call(createPardotFormAPI);
        if (response) {
            yield put(creatingPardotFormSucceeded(response));
        }
    } catch (error) {
        yield put(creatingPardotFormFailed(error));
    }
}


/**
 * Update Pardot form
 */
export const updatePardotForm = createAction(UPDATING_PARDOT_FORM_REQUEST, (request) => {
    return {
        request: request
    }
})

const updatingPardotFormSucceeded = createAction(UPDATING_PARDOT_FORM_SUCCEEDED, (response) => {
    return response;
})

const updatingPardotFormFailed = createAction(UPDATING_PARDOT_FORM_FAILED, (error) => {
    return {
        error: error
    }
})

function* updatePardotFormSaga(action) {
    const { request } = action.payload;

    const updatePardotFormAPI = () => {
        return axios.put(PARDOT_FORM_URL, request).then(response => response.data);
    }

    try {
        const response = yield call(updatePardotFormAPI);
        yield put(updatingPardotFormSucceeded(response));
    } catch (error) {
        yield put(updatingPardotFormFailed(request.formId, error));
    }
}


/**
 * Delete Pardot form
 */
export const deletePardotForm = createAction(DELETING_PARDOT_FORM_REQUEST, (type, formId) => {
    return {
        type: type,
        formId: formId
    }
})

const deletingPardotFormSucceeded = createAction(DELETING_PARDOT_FORM_SUCCEEDED, (type, formId) => {
    return {
        type: type,
        formId: formId
    }
})

const deletingPardotFormFailed = createAction(DELETING_PARDOT_FORM_FAILED, (type, formId, error) => {
    return {
        type: type,
        formId: formId,
        error: error
    }
})

function* deletePardotFormSaga(action) {
    const { type, formId } = action.payload;

    const params = {
        formId: formId
    };

    let url = buildUrl(PARDOT_FORM_URL, {
        queryParams: params
    });

    const deletePardotFormAPI = () => {
        return axios.delete(url).then(response => response.data);
    }

    try {
        const response = yield call(deletePardotFormAPI);
        yield put(deletingPardotFormSucceeded(type, formId));
    } catch (error) {
        yield put(deletingPardotFormFailed(type, formId, error));
    }
}

export default function* pardotFormsSaga() {
    yield takeEvery(CREATING_PARDOT_FORM_REQUEST, createPardotFormSaga);
    yield takeEvery(UPDATING_PARDOT_FORM_REQUEST, updatePardotFormSaga);
    yield takeEvery(DELETING_PARDOT_FORM_REQUEST, deletePardotFormSaga);
}